package br.com.vvrefeicoes.portal.domain.model

/** Colunas da listagem da RMP que o RH ajusta ao portal. `UNIDADE` aponta para uma unidade; as demais, para um usuário. */
enum class RmpLinkField {
    UNIDADE,
    SOLICITANTE,
    DIRETORA_DESTINO,
    DIRETOR,
    DIRETORA_GERAL_CEO,
    RH,
    ;

    val isUnit: Boolean get() = this == UNIDADE
}

/**
 * Uma coluna ajustável de um RMP: o valor na RMP (e a data de aprovação, quando houver), o ajuste salvo para este
 * RMP (`target*`) e a sugestão, que só é gravada se o RH usar. Sem `rmpName` a coluna não se aplica a este RMP.
 */
data class RmpSyncCell(
    val field: RmpLinkField,
    val rmpName: String? = null,
    val rmpEmail: String? = null,
    val date: String? = null,
    val targetId: String? = null,
    val targetName: String? = null,
    val suggestedId: String? = null,
    val suggestedName: String? = null,
) {
    val applies: Boolean get() = !rmpName.isNullOrBlank()
    val pending: Boolean get() = applies && targetId == null
}

/** Um RMP na aba Sync, com as colunas da listagem da RMP. ID, tipo, status e datas são só para conferência. */
data class RmpSyncRecord(
    val id: String,
    val rmpId: Long,
    val type: String? = null,
    val status: String? = null,
    val createdAt: String? = null,
    val unit: RmpSyncCell,
    val requester: RmpSyncCell,
    val destinationDirector: RmpSyncCell,
    val director: RmpSyncCell,
    val generalDirector: RmpSyncCell,
    val hr: RmpSyncCell,
)

/** `totalRmps`/`rmpsPending`/`cellsPending` consideram status e tipo, mas não a busca nem "só com pendência". */
data class RmpSyncPage(
    val records: List<RmpSyncRecord>,
    val totalPages: Int,
    val totalElements: Long,
    val totalRmps: Long,
    val rmpsPending: Long,
    val cellsPending: Long,
)

/** Unidade ou usuário do portal oferecido no ajuste (`detail`: e-mail do usuário). */
data class RmpPortalOption(
    val id: String,
    val name: String,
    val detail: String? = null,
)

/** Abas da Sync: RMPs com alguma coluna sem ajuste ou com todas as colunas já ajustadas. */
enum class RmpSyncSituation { PENDENTES, AJUSTADOS }

/** Filtro de status da Sync; em andamento e rejeitados também precisam de ajuste para não perder os anexos. */
enum class RmpSyncStatusFilter { FINALIZADOS, EM_ANDAMENTO, REJEITADOS, TODOS }
